import { createSlice } from '@reduxjs/toolkit';

const journalSlice = createSlice({
  name: 'journal',
  initialState: {
    readings: JSON.parse(localStorage.getItem('tarotReadings')) || [],
  },
  reducers: {
    addReading(state, action) {
      state.readings.unshift(action.payload);
      localStorage.setItem('tarotReadings', JSON.stringify(state.readings));
    },
    deleteReading(state, action) {
      state.readings = state.readings.filter((r) => r.id !== action.payload);
      localStorage.setItem('tarotReadings', JSON.stringify(state.readings));
    },
    updateReadingInterpretation(state, action) {
      const { readingId, interpretation } = action.payload;
      const existingReading = state.readings.find((r) => r.id === readingId);
      if (existingReading) {
        existingReading.interpretation = interpretation;
        localStorage.setItem('tarotReadings', JSON.stringify(state.readings));
      }
    },
  },
});

export const { addReading, deleteReading, updateReadingInterpretation } = journalSlice.actions;
export default journalSlice.reducer;
